import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    setPulledEffects
} from 'actions/index.js';
import {LIVE_FX, AUDIO_FX} from 'constants/effect-types.js';
import EffectComponent from "components/effects/EffectComponent.js";
import PulledEffect from "components/pulled/PulledEffect.js";
import MidiEffectComponent from "components/effects/MidiEffectComponent.js";
import LiveEffectComponent from "components/effects/LiveEffectComponent.js";

import {connect} from 'react-redux';

const PulledEffects = ({
    containerRef,
    sizeRef,
    setSize,
    size,
    all,
    pulledEffects,
    sequencerEngine,
    setPulledEffects,
    scale,
    currentSubSequence,
    playhead,
    noWrapper,
    elements,
    ordering,
    setOrdering,
}) => { 
    const _elements = useRef({});
    const onDelete = useCallback((fx) => {
        setPulledEffects(pulledEffects.filter(f => f !== fx));
    }, [pulledEffects]);

    const getTrack = (e) => {
        if (e && e.getEffectType && e.getEffectType() !== AUDIO_FX && e.track) {
            return e.track;
        }
        if (e.context) {
            return e.context.track;
        }
        return e.track;
    };

    const shouldShow = useCallback((e) => {
        if (!e) {
            return false;
        }
        if (!getTrack(e)) {
            return e.track === currentSubSequence;
        }
        return all || getTrack(e).subSequence === currentSubSequence ||
            getTrack(e) === currentSubSequence;
    }, [currentSubSequence, all]);


    let _effects = pulledEffects
        .filter(shouldShow);
    if (playhead) {
        _effects.push(currentSubSequence.playhead);
    }
    let inner = _effects
        .map(fx => <PulledEffect
                     key={fx.id}
                     scale={scale}
                     elements={elements || _elements}
                     sizeRef={sizeRef}
                     setOrdering={setOrdering}
                     ordering={ordering}
                     containerRef={containerRef}
                     size={size}
                     setSize={setSize}
                     effects={_effects}
                     onDelete={onDelete}
                     sequencerEngine={sequencerEngine}
                     fx={fx}/>);
    if (noWrapper) {
        return inner;
    }
    return (
        <div className="pulled-effects">
          {inner}
        </div>);
};

const mapStateToProps = (state, props) => {
    return {
        pulledEffects: state.effects.pulledEffects,
        currentSubSequence: props.subSequence || props.sequencerEngine.currentSubSequence
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPulledEffects: e => dispatch(setPulledEffects(e)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PulledEffects);
